import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-chat-header',
  templateUrl: './chat-header.component.html',
  styleUrls: ['./chat-header.component.scss']
})
export class ChatHeaderComponent implements OnInit, OnChanges {
  
  @Input("userflag") userflag = false;
  @Input("currentUser") currentUser:any;
  @Output('arrowBack') arrowBack = new EventEmitter<any>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['currentUser'].currentValue != changes['currentUser'].previousValue) {
      this.currentUser = changes['currentUser'].currentValue
    }
  }

  ngOnInit(): void {}

  arrowBackfunc() {
    this.arrowBack.emit(true);
  }

}
